import React from "react";
import { Button } from "../../../../UI/Button/Button";
import "./StartNow.css";

import StartNowBlocks1 from "../../../../assets/svg/StartNowBlocks1";
import StartNowBlocks2 from "../../../../assets/svg/StartNowBlocks2";
import { useFade } from "../../../../hooks/useFade";

export const StartNow = ({ account, handleConnect, startNowImages }) => {
  useFade("up", [".fade-up"]);

  return (
    <section className="start-section">
      <div className="start-section_container">
        <span className="start-blocks-1-wrap fade-up">
          <StartNowBlocks1 className={"start-blocks-1"} />
        </span>
        <span className="start-blocks-2-wrap fade-up">
          <StartNowBlocks2 className={"start-blocks-2"} />
        </span>
        <div className="start-titles-wrapper">
          <h2 className="start-title fade-up">start now</h2>
          <h4 className="start-title-sm fade-up">
            Connect your crypto wallet to start using the app in seconds. No
            registration needed.
          </h4>
        </div>
        <span className="fade-up">
          {account ? null : (
            <a
              href="https://www.npmjs.com/package/@hypersokrat/hyper-pay"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleConnect}
            >
              <Button
                label={"Download Now"}
                size={"btn-lg"}
                type={"btn-darkBlue-secondary"}
                arrow={"arrow-none"}
                element={"button"}
                onClick={() => {}}
              />
            </a>
          )}
        </span>
      </div>

      <div className="corners-bg" />
    </section>
  );
};
